import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";

//-------------------------------------------
//           API Functions
//-------------------------------------------


const COMPANY_BASE = "/Company";

const getCompanyAPI = () => API.get(`${COMPANY_BASE}`);
const addCompanyAPI = (id, code, data) =>
    API.post(`${COMPANY_BASE}/${id}/${code}`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });
const updateCompanyAPI = (id, data) =>
    API.patch(`${COMPANY_BASE}/${id}`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });


//-------------------------------------------
//             Company Service
//-------------------------------------------

const baseService = createApplicationService({
    name: "company",
    apiFetchFn: getCompanyAPI,
    apiAddFn: addCompanyAPI,
    apiUpdateFn: updateCompanyAPI,
});

const companyReducer = baseService.reducer;
const getCompany = baseService.getData;
const addCompany = baseService.addData;
const updateCompany = baseService.updateData;
const useCompany = baseService.useData;
const resetCompanyCache = baseService.resetData;


export {
    companyReducer,
    getCompany,
    addCompany,
    updateCompany,
    useCompany,
    resetCompanyCache,
};
